import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1 0%;
  min-height: 0;
  overflow-y: auto;
  margin-top: 2px;
  padding-top: 6px;
  padding-bottom: 80px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 568px) {
    height: ${props => (props.floating ? 'calc(100% - 112px)' : '')};
  }
`;

export default Content;
